module.exports = __webpack_public_path__ + "img/video_icon01.6a5f9572.png";